import { render, staticRenderFns } from "./RestrictionWithdrawal.vue?vue&type=template&id=3dbdeb01"
import script from "./RestrictionWithdrawal.vue?vue&type=script&lang=js"
export * from "./RestrictionWithdrawal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports